// ofuro-wiki: Calendar integration not available
export const IntegrationsPanel = () => {
  return null;
};
